import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["row"]

    accept(e) {
        const id = e.currentTarget.dataset.id
        this._optimisticRemove(id)
        // TODO: fetch to /proposals/:id/accept (POST)
        // fetch(...).catch(() => this._rollback(id))
    }

    reject(e) {
        const id = e.currentTarget.dataset.id
        this._optimisticRemove(id)
        // TODO: fetch vers /proposals/:id/reject (POST)
        // fetch(...).catch(() => this._rollback(id))
    }

    _optimisticRemove(id) {
        const row = this._rowById(id)
        if (!row) return
        row.classList.add("is-leaving")
        setTimeout(() => row.remove(), 220)
    }

    _rollback(id) {
        // TODO
    }

    _rowById(id) {
        return this.rowTargets.find(el => el.dataset.id === id)
    }
}